module.exports = __webpack_public_path__ + "img/type_bq.53f1ed00.png";